import React from 'react'
import SideBarImg from '../../img/sidebar.png'
const SideBar = () => {
    return (
        <div className="sideBarContainer">
            <img alt="" src={SideBarImg} />
        </div>
    );
}
export default SideBar;